import { getItem, writeItem } from "tools/localStorage";
import roundCartQuantity from "tools/product/roundCartQuantity";
import {
  FullProduct,
  LocalStorageExtraProduct,
  LocalStorageProduct,
} from "ts/api/product";

const STORAGE_PRODUCTS_KEY = "products";

export const decrementQuantityOrRemoveCartProduct = (productId: string) => {
  const cartProducts = getItem<LocalStorageProduct[]>("products", []);
  if (!cartProducts.length) {
    return;
  }

  const newProducts = cartProducts.reduce<LocalStorageProduct[]>(
    (acc, curr) => {
      if (curr.id === productId && curr.cartQuantity > 1) {
        acc.push({ ...curr, cartQuantity: curr.cartQuantity - 1 });
      } else {
        acc.push(curr);
      }

      return acc;
    },
    []
  );

  writeItem<LocalStorageProduct[]>("products", newProducts);
};

export const updateProductCartQuantity = (
  product: FullProduct,
  newQuantity: number
) => {
  const cartProducts = getItem<LocalStorageProduct[]>(STORAGE_PRODUCTS_KEY, []);
  if (!cartProducts.length) {
    return;
  }
  const quantity = roundCartQuantity(newQuantity);

  const newProducts = cartProducts.map((storageProduct) => {
    if (storageProduct.id !== product.id) {
      return storageProduct;
    }
    const newExtras = (storageProduct.extras ?? []).map((storageExtra) => {
      const extraProduct = product.extras?.find(
        (e) => e.id === storageExtra.id
      );

      return {
        ...storageExtra,
        ...(extraProduct?.isSelectedByDefault && { quantity }),
      };
    });

    return {
      ...storageProduct,
      cartQuantity: quantity,
      ...(newExtras.length && { extras: newExtras }),
    };
  });
  writeItem<LocalStorageProduct[]>(STORAGE_PRODUCTS_KEY, newProducts);

  triggerCartStorageEvt(newProducts, cartProducts);
};

export const triggerCartStorageEvt = (
  newValue: LocalStorageProduct[],
  oldValue?: LocalStorageProduct[]
) => {
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: STORAGE_PRODUCTS_KEY,
      ...(oldValue && { oldValue: JSON.stringify(oldValue) }),
      newValue: JSON.stringify(newValue),
      storageArea: localStorage,
      url: window.location.href,
    })
  );
};
